import { jsx } from "panel";
import { AnnotationsMixin } from "./annotations/template";
export function template() {
  const Annotations = AnnotationsMixin.bind(this);
  return /* @__PURE__ */ jsx("div", {
    sel: ".root"
  }, /* @__PURE__ */ jsx("div", null, this.attr(`show-annotations`) && this.state.annotations ? /* @__PURE__ */ jsx(Annotations, null) : null));
}
